"use client";

import React, { ReactNode } from "react";

export interface TableContainerProps {
  // Navigation tabs (top section)
  navigationTabs?: ReactNode;

  // Header section with title/brand + controls
  headerLeft?: ReactNode; // Title, brand, or left side content
  headerRight?: ReactNode; // Search, filters, action buttons

  // Filter panel (collapsible section)
  filterPanel?: ReactNode;
  showFilterPanel?: boolean;

  // Main table content
  children: ReactNode;

  // Layout customization
  className?: string;
}

export const TableContainer: React.FC<TableContainerProps> = ({
  navigationTabs,
  headerLeft,
  headerRight,
  filterPanel,
  showFilterPanel = false,
  children,
  className = "",
}) => {
  return (
    <div className={`space-y-4 flex flex-col h-full ${className}`}>
      {/* Navigation Tabs Section */}
      {navigationTabs && (
        <div className="flex justify-between flex-wrap gap-4">
          {navigationTabs}
        </div>
      )}

      {/* Header Section */}
      {(headerLeft || headerRight) && (
        <div className="flex justify-between flex-wrap gap-4">
          {headerLeft && <div className="flex items-center">{headerLeft}</div>}
          {headerRight && (
            <div className="flex items-center">{headerRight}</div>
          )}
        </div>
      )}

      {/* Filter Panel Section */}
      {showFilterPanel && filterPanel && (
        <div className="w-full">{filterPanel}</div>
      )}

      {/* Main Table Content */}
      <div className="w-full flex-1 min-h-0">{children}</div>
    </div>
  );
};

export default TableContainer;
